import { render, staticRenderFns } from "./validMailbox.vue?vue&type=template&id=a628bf7c&scoped=true&"
import script from "./validMailbox.vue?vue&type=script&lang=js&"
export * from "./validMailbox.vue?vue&type=script&lang=js&"
import style0 from "./validMailbox.vue?vue&type=style&index=0&id=a628bf7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a628bf7c",
  null
  
)

export default component.exports